import styled from "@emotion/styled";
import { PRIMARY_BLACK } from "src/constants/colors";

export const BaseCell = styled.div`
  color: ${PRIMARY_BLACK};
  display: flex;
  flex: 1;
  align-items: center;
  font-size: 14px;
  padding: 25px 0px;
  text-align: left;
  line-height: 1cap;
  white-space: nowrap;
`;
